var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.88 22.73-2.17-.3c-1.04-.14-1.98-1.07-2.14-2.13l-.3-2.19c-.1-.7.2-1.61.7-2.12l4.39-4.39c-.71-2.84.11-5.84 2.2-7.91 3.24-3.23 8.51-3.24 11.76 0a8.26 8.26 0 0 1 2.43 5.88c0 2.22-.86 4.31-2.43 5.88-2.1 2.08-5.09 2.9-7.91 2.18l-4.4 4.39c-.42.44-1.17.73-1.83.73-.1 0-.21-.01-.3-.02zM9.61 4.75a6.803 6.803 0 0 0-1.7 6.85c.08.27.01.55-.19.75l-4.7 4.7c-.17.17-.31.61-.28.84l.3 2.19c.06.38.47.81.85.86l2.18.3c.24.04.68-.1.85-.27l4.72-4.71c.2-.2.49-.26.75-.18 2.41.76 5.04.11 6.84-1.69 1.28-1.28 1.99-3 1.99-4.82 0-1.83-.71-3.54-1.99-4.82a6.727 6.727 0 0 0-4.8-1.99c-1.75 0-3.49.66-4.82 1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.66 20.32-2.3-2.3a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9.5c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25-1.01 2.25-2.25 2.25-2.25-1.01-2.25-2.25zm1.5 0c0 .41.34.75.75.75s.75-.34.75-.75-.34-.75-.75-.75-.75.34-.75.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineKey);
export default __webpack_public_path__ + "static/media/vuesax-outline-key.0e016df16458c509463109eb42036ae4.svg";
export { ForwardRef as ReactComponent };